import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { LoadingBehaviorSubject } from './loading-behavior-subject.helper';

export const IsOneStreamLoading = (
    loaderStreams: (LoadingBehaviorSubject | Observable<boolean>)[]
): Observable<boolean> => {
    return combineLatest(loaderStreams).pipe(
        map(loaderValues => loaderValues.some(isLoading => isLoading)),
        distinctUntilChanged()
    );
};
